import Vue from '@landing-desktop/consts/vue'
import format from '@common/utils/discountText'

export default function discountText(value) {
  return format(value, Vue.prototype.$consts.layoutDiscount)
}
